/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/468-xing': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zM4.884 10.406H3.156a.253.253 0 01-.225-.119c-.047-.075-.047-.169 0-.266l1.838-3.244c.003-.003.003-.006 0-.009L3.6 4.743c-.047-.097-.056-.191-.009-.266.044-.072.131-.109.237-.109h1.731c.266 0 .397.172.481.325 0 0 1.181 2.063 1.191 2.075-.069.125-1.869 3.303-1.869 3.303-.094.162-.219.334-.478.334zm8.185-8.028L9.238 9.153a.01.01 0 000 .012l2.441 4.456c.047.097.05.194.003.269-.044.072-.125.109-.231.109H9.723c-.266 0-.397-.175-.484-.328L6.78 9.159l3.85-6.828c.094-.166.206-.328.463-.328h1.753c.103 0 .188.041.231.109.044.072.044.169-.006.266z"/>'
  }
})
